module.exports = __webpack_public_path__ + "static/media/companyIcon.dc511d4c.svg";